export function DashboardSkeleton() {
    return (
        <div className="space-y-6 animate-pulse p-1">
            {/* Header Skeleton */}
            <div className="flex justify-between items-center mb-8">
                <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-slate-200 dark:bg-slate-700 rounded-lg"></div>
                    <div className="space-y-2">
                        <div className="h-4 w-48 bg-slate-200 dark:bg-slate-700 rounded"></div>
                        <div className="h-3 w-32 bg-slate-200 dark:bg-slate-700 rounded"></div>
                    </div>
                </div>
                <div className="w-24 h-8 bg-slate-200 dark:bg-slate-700 rounded-lg"></div>
            </div>

            {/* Stats Grid Skeleton */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="h-32 bg-slate-200 dark:bg-slate-800 rounded-xl border border-slate-300 dark:border-slate-700"></div>
                ))}
            </div>

            {/* Main Content Grid Skeleton */}
            <div className="grid grid-cols-1 lg:grid-cols-10 gap-8">
                {/* Left Col (Map) */}
                <div className="col-span-1 lg:col-span-10 xl:col-span-7 space-y-4">
                    <div className="h-[400px] bg-slate-200 dark:bg-slate-800 rounded-xl border border-slate-300 dark:border-slate-700"></div>
                </div>

                {/* Right Col (List) */}
                <div className="col-span-1 lg:col-span-10 xl:col-span-3 space-y-4">
                    <div className="h-[400px] bg-slate-200 dark:bg-slate-800 rounded-xl border border-slate-300 dark:border-slate-700"></div>
                </div>
            </div>

        </div>
    );
}
